var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalClose2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clear_24px",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/content/clear_24px",
    d: "M18.3002 6.55322C18.1134 6.36597 17.8597 6.26073 17.5952 6.26073C17.3307 6.26073 17.077 6.36597 16.8902 6.55322L12.0002 11.4332L7.11021 6.54322C6.92338 6.35597 6.66973 6.25073 6.40521 6.25073C6.1407 6.25073 5.88705 6.35597 5.70021 6.54322C5.31021 6.93322 5.31021 7.56322 5.70021 7.95322L10.5902 12.8432L5.70021 17.7332C5.31021 18.1232 5.31021 18.7532 5.70021 19.1432C6.09021 19.5332 6.72021 19.5332 7.11021 19.1432L12.0002 14.2532L16.8902 19.1432C17.2802 19.5332 17.9102 19.5332 18.3002 19.1432C18.6902 18.7532 18.6902 18.1232 18.3002 17.7332L13.4102 12.8432L18.3002 7.95322C18.6802 7.57322 18.6802 6.93322 18.3002 6.55322Z",
    fill: "#2F374D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose2);
export default __webpack_public_path__ + "static/media/modal_close2.c464848af9eec7dd987a42d7405a1656.svg";
export { ForwardRef as ReactComponent };